//import LocalStorage from 'localStorage'
import Hosts from '../../Hosts';

const object_type = 'tarefa'

const api_crud_base = Hosts.SIMCore_API
const api_crud_route = `${Hosts.SIMCore_API}/${object_type}`
//const api_list_route = `${Hosts.SIMCore_API}/cpf`
const api_list_route = companycode => `${Hosts.SIMCore_API}/${object_type}/${companycode}`


const base_endpoint = '/intranet_tarefa'

const endpoints = {
    base: base_endpoint,
    regist: `${base_endpoint}_regist`,
    list: `${base_endpoint}_list`,
    view: `${base_endpoint}_view`,
}

const data_interface = {
    id: '',
    info: {
        anexos :[],
        unique_code: '',
        companycode: '',

        name: '',
        empresaid: '',
        nomeEmpresa: '',

        departamento: [],
        monitor: [],
        responsaveis: [],
        estado: '',
        prioridade: [],
        description: '',

        data_inicio: '',
        data_limite: '',
        dataConfirmacao: '',
        dataSubmissao: '',   
        dataConclusao: '',        

        solucao: [],
        submissoes: [],
        notifications: [],
        
        confirmar: false,
        submeter: false,
        validar: false,
        detalhes:'',                  
    },
}

export {
    object_type,
    endpoints,
    api_crud_base,
    api_crud_route,
    data_interface,
    api_list_route
}
